module.exports = "https://static.energy5.com/_next/static/images/check-c86ac90aabf14ee5fb16cde3014757fe.png";